import http from '@/utils/http';
const URL_BASE = '/cultura';

export default {
    buscarCultura(lockScreen = true) {
        return http.get({
            url: URL_BASE,
            lockScreen: lockScreen
        });
    }
};
